var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabBar",style:({
    background: _vm.datas.backColor,
  })},[_c('div',{style:({
      background: _vm.datas.backColor,
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[_c('section',{staticClass:"nav_con"},[(_vm.datas.imageList.length == 0)?_vm._l((4),function(index){return _c('div',{key:index,class:['nav_item']},[(_vm.datas.styleType != 1)?_c('img',{attrs:{"draggable":"false","src":_vm.defaultImg,"alt":""}}):_vm._e(),(_vm.datas.styleType != 2)?_c('div',{style:({
              'font-size': _vm.datas.wordSize + 'px',
              'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
              'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
              'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
              color: _vm.datas.wordColor,
            })}):_vm._e()])}):_vm._l((_vm.datas.imageList),function(item,index){return _c('div',{key:index,class:[
            { goods_type_item_active: _vm.activeTab == index },
            'nav_item' ],on:{"click":function($event){return _vm.handleChangeType(index)}}},[(_vm.datas.styleType != 1)?_c('img',{attrs:{"src":index == _vm.activeTab
                ? item.activeImgUrl || _vm.defaultImg
                : item.imgUrl || _vm.defaultImg,"alt":""}}):_vm._e(),(_vm.datas.styleType != 2)?_c('div',{style:({
              'font-size':
                (index == _vm.activeTab ? _vm.datas.wordSizeActive : _vm.datas.wordSize) +
                'px',
              'font-weight': _vm.handleSetBoldStyle(
                index == _vm.activeTab ? _vm.datas.isBoldActive : _vm.datas.isBold
              ),
              'font-style': _vm.handleSetTiltStyle(
                index == _vm.activeTab ? _vm.datas.isTiltActive : _vm.datas.isTilt
              ),
              'text-decoration': _vm.handleSetUnderLineStyle(
                index == _vm.activeTab
                  ? _vm.datas.isUnderLineActive
                  : _vm.datas.isUnderLine
              ),
              color:
                index == _vm.activeTab ? _vm.datas.wordColorActive : _vm.datas.wordColor,
            })},[_vm._v(" "+_vm._s(item.title ? item.title : "")+" ")]):_vm._e()])})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }